// extracted by mini-css-extract-plugin
export default {"customMuiPopoverpd":"ProfileSection_customMuiPopoverpd__fBOaw"};